export const es = {
  'nav.ofertas': 'Ofertas',
  'nav.profesionales': 'Profesionales',
  'nav.empresas': 'Empresas',
  'content.hubTitle': 'Actualidad y agenda',
  'content.hubSubtitle': 'Noticias, cursos y eventos del sector. Todo lo que necesitas para estar al día, en un mismo lugar.',
  'content.all': 'Todo', 'content.news': 'Noticias', 'content.training': 'Cursos', 'content.events': 'Eventos',
  'content.filter': 'Filtrar contenido', 'content.search': 'Buscar noticias, cursos o eventos…', 'content.readOnly': 'Selección editorial',
  'content.viewAll': 'Ver actualidad y agenda',

  'nav.actualidad': 'Actualidad',
  'nav.formacion': 'Formación',
  'nav.eventos': 'Eventos',
  'nav.forum': 'Foro',
  'nav.biblioteca': 'Biblioteca',
  'nav.colaboracion': 'Colaboración',
  'nav.donaciones': 'Donaciones',
  'nav.mercado': 'Mercado',
  'nav.login': 'Entrar',
  'nav.register': 'Crear cuenta',
  'nav.publish': 'Publicar oferta',
  'nav.search': 'Buscar',

  'hero.title': 'El punto de encuentro profesional de las artes escénicas',
  'hero.subtitle': 'Encuentra trabajo, profesionales, empresas y oportunidades del sector técnico.',
  'hero.searchPlaceholder': 'Técnico de iluminación, GrandMA3, rigging...',
  'hero.locationPlaceholder': 'Barcelona',
  'hero.searchWhat': '¿Qué estás buscando?',
  'hero.searchButton': 'Buscar',
  'hero.quick.jobs': 'Buscar ofertas',
  'hero.quick.pros': 'Buscar profesionales',
  'hero.quick.companies': 'Buscar empresas',

  'section.categories': 'Especialidades técnicas',
  'section.categories.sub': 'Encuentra profesionales y ofertas por especialidad',
  'section.latestJobs': 'Últimas ofertas',
  'section.latestJobs.sub': 'Oportunidades recientes del sector técnico',
  'section.viewAll': 'Ver todas las ofertas',
  'section.pros': 'Encuentra profesionales',
  'section.pros.sub': 'Busca técnicos según especialidad, experiencia, ubicación, disponibilidad y conocimientos técnicos.',
  'section.pros.cta': 'Buscar profesionales',
  'section.companies': 'Empresas del sector',
  'section.companies.sub': 'Directorio de empresas técnicas verificadas',
  'section.companies.cta': 'Ver empresas',
  'section.news': 'Actualidad del sector',
  'section.news.sub': 'Noticias, tecnología y tendencias del backstage',
  'section.news.cta': 'Ver actualidad',
  'section.training': 'Formación',
  'section.training.sub': 'Cursos, certificaciones y talleres del sector técnico',
  'section.training.cta': 'Ver formación',
  'section.events': 'Eventos del sector',
  'section.events.sub': 'Ferias, congresos y encuentros profesionales',
  'section.events.cta': 'Ver eventos',
  'section.stats': 'La realidad del sector',
  'section.stats.sub': 'Datos agregados de la comunidad Stage Crew',
  'section.stats.demoNote': 'Datos de muestra · Se activarán con datos reales',

  'cta.employer.title': '¿Buscas personal técnico?',
  'cta.employer.text': 'Publica tu oferta y encuentra profesionales del sector.',
  'cta.employer.button': 'Publicar una oferta',
  'cta.employer.note': 'Gratis para empezar',

  'badge.verified': 'Verificada',
  'badge.professionalPublished': 'Publicada por profesional',
  'badge.substitution': 'Sustitución',
  'badge.urgent': 'Urgente',
  'badge.available': 'Disponible',
  'badge.onTour': 'En bolos',
  'badge.demo': 'DEMO',

  'jobtype.trabajo': 'Trabajo',
  'jobtype.sustitucion': 'Sustitución',
  'jobtype.refuerzo': 'Refuerzo',
  'jobtype.bolsa': 'Bolsa de trabajo',
  'jobtype.urgente': 'Urgente',
  'jobtype.otro': 'Otro',

  'application.sent': 'Candidatura enviada',
  'application.withdraw': 'Retirar candidatura',
  'application.withdrawing': 'Retirando…',
  'application.withdrawSuccess': 'Candidatura retirada. Puedes volver a enviarla mientras la oferta siga abierta.',
  'application.withdrawError': 'No se pudo retirar la candidatura. Inténtalo de nuevo.',
  'application.withdrawHint': 'Pulsa de nuevo para retirar tu candidatura. Podrás volver a inscribirte mientras la oferta siga abierta.',
  'application.closedHint': 'La oferta está cerrada. Contacta con quien la publicó si necesitas comunicar un cambio.',

  'label.applicants': 'candidaturas',
  'label.deadline': 'Fecha límite',
  'label.publishedBy': 'Publicada por',
  'label.location': 'Ubicación',
  'label.schedule': 'Horario',
  'label.compensation': 'Retribución',
  'label.skills': 'Habilidades técnicas',
  'label.experience': 'Experiencia',
  'label.availability': 'Disponibilidad',
  'label.specialties': 'Especialidades',
  'label.activeJobs': 'ofertas activas',
  'label.rating': 'Valoración',
  'label.readMore': 'Leer más',
  'label.viewOffer': 'Ver oferta',
  'label.viewProfile': 'Ver perfil',
  'label.viewCompany': 'Ver empresa',
  'label.viewDetails': 'Ver detalles',
  'label.date': 'Fecha',
  'label.category': 'Categoría',
  'label.source': 'Fuente',
  'label.modality': 'Modalidad',
  'label.price': 'Precio',
  'label.school': 'Escuela',
  'label.sponsored': 'Patrocinado',
  'label.timeSlots': 'Franjas horarias',
  'label.totalHours': 'Total de horas',
  'label.hoursShort': 'h',
  'label.phone': 'Teléfono',
  'label.certifications': 'Certificaciones',

  'gate.title': 'Zona reservada para miembros',
  'gate.subtitle': 'Únete a STAGE CREW y disfruta de todas las ventajas de nuestra comunidad. Crea tu perfil gratis y accede a todas sus funciones.',
  'gate.login': 'Entrar',
  'gate.register': 'Crear cuenta gratis',

  'profile.title': 'Mi perfil profesional',
  'profile.subtitle': 'Completa tu ficha y decide qué información se muestra públicamente. Los campos ocultos nunca se comparten con otros usuarios.',
  'profile.section.public': 'Información pública',
  'profile.section.contact': 'Contacto',
  'profile.section.skills': 'Habilidades y certificaciones',
  'profile.section.privacy': 'Privacidad · qué se muestra',
  'profile.visibility.on': 'Público',
  'profile.visibility.off': 'Oculto',
  'profile.save': 'Guardar cambios',
  'profile.saved': 'Cambios guardados',
  'profile.error': 'No se pudo guardar. Inténtalo de nuevo.',
  'profile.field.role': 'Cargo / especialidad',
  'profile.field.category': 'Categoría',
  'profile.field.location': 'Ubicación',
  'profile.field.experience': 'Experiencia',
  'profile.field.availability': 'Disponibilidad',
  'profile.field.bio': 'Bio profesional',
  'profile.field.phone': 'Teléfono',
  'profile.field.email': 'Email de contacto',
  'profile.field.skills': 'Habilidades técnicas (separadas por coma)',
  'profile.field.certifications': 'Certificaciones (separadas por coma)',
  'profile.myLink': 'Mi perfil',

  'footer.tagline': 'La comunidad profesional de las artes escénicas',
  'footer.ofertas': 'Ofertas',
  'footer.profesionales': 'Profesionales',
  'footer.empresas': 'Empresas',
  'footer.comunidad': 'Comunidad',
  'footer.stagecrew': 'Stage Crew',
  'footer.legal': 'Legal',
  'footer.allJobs': 'Todas las ofertas',
  'footer.searchPros': 'Buscar profesionales',
  'footer.createProfile': 'Crear perfil',
  'footer.searchCompanies': 'Buscar empresas',
  'footer.registerCompany': 'Registrar empresa',
  'footer.publishJob': 'Publicar oferta',
  'footer.about': 'Sobre Stage Crew',
  'footer.contact': 'Contacto',
  'footer.collaborate': 'Colabora',
  'footer.advertising': 'Publicidad',
  'footer.terms': 'Términos de uso',
  'footer.privacy': 'Privacidad',
  'footer.cookies': 'Cookies',
  'footer.copyright': '© 2026 Stage Crew · Todos los derechos reservados',

  'auth.login.title': 'Bienvenido de nuevo',
  'auth.login.subtitle': 'Accede a tu cuenta Stage Crew',
  'auth.register.title': 'Únete a Stage Crew',
  'auth.register.subtitle': 'Crea tu cuenta profesional en menos de un minuto',
  'auth.email': 'Correo electrónico',
  'auth.password': 'Contraseña',
  'auth.name': 'Nombre completo',
  'auth.accountType': 'Tipo de cuenta',
  'auth.accountPro': 'Profesional',
  'auth.accountCompany': 'Empresa',
  'auth.submit.login': 'Entrar',
  'auth.submit.register': 'Crear cuenta',
  'auth.noAccount': '¿No tienes cuenta?',
  'auth.hasAccount': '¿Ya tienes cuenta?',
  'auth.demoNotice': 'Autenticación en modo demo — pendiente de backend',

  'meta.filters': 'Filtros',
  'meta.results': 'resultados',
  'meta.sortBy': 'Ordenar por',
  'meta.newest': 'Más recientes',
  'meta.oldest': 'Más antiguas',

  'empty.title': 'Sin resultados',
  'empty.subtitle': 'Prueba ajustando los filtros de búsqueda',
};
